(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isMobile = window.innerWidth <= 480; // Only consider screens below 480px as mobile
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);
        
        // Always keep open on mobile if the setting is enabled, but treat tablets like desktop
        //if (isMobile && {{ section.settings.always_show_mobile_menu | default: true }}) {
        if (isMobile) {
          this.disclosure.open = true;
        } else {
          this.disclosure.open = isLargeScreen || isConfirmNewsletter;
        }

        if (isLargeScreen || (window.innerWidth > 480 && window.innerWidth <= 767)) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
      customElements.whenDefined('details-disclosure').then(() => {
        class NavMenu extends DetailsDisclosure {
          constructor() {
            super();

            if (this.matches('.js-mega-nav')) {
              this.attachDesktopHoverListeners();
              window.addEventListener('on:breakpoint-change', () => this.reset());
              this.reset();
            }
          }

          attachDesktopHoverListeners() {
            this.addEventListener('mouseenter', () => {
              if (window.matchMedia(theme.mediaQueries.md).matches) {
                this.disclosure.setAttribute('open', '');
              }
            });

            this.addEventListener('mouseleave', () => {
              if (window.matchMedia(theme.mediaQueries.md).matches) {
                this.disclosure.removeAttribute('open');
              }
            });
          }

          reset() {
            const desktop = window.matchMedia(theme.mediaQueries.md).matches;

            /*  desktop: keep collapsed until hover
                mobile : clean slate, let <details> work on tap                */
            if (desktop) {
              this.disclosure.removeAttribute('open');
              this.toggle.setAttribute('tabindex', '-1'); // non-focusable on desktop
            } else {
              // Do not remove 'open' here – let mobile users toggle it manually
              this.toggle.removeAttribute('tabindex');
            }

          }

          /* stop DetailsDisclosure’s own click-to-toggle on desktop only    */
  handleToggle(e) {
    const isDesktop = window.matchMedia(theme.mediaQueries.md).matches;
    if (isDesktop) {
      e.preventDefault(); // block default only on desktop
    }
  }

        }

        customElements.define('nav-menu', NavMenu, { extends: 'details' });
      });

  } catch(e) { console.error(e); }
})();
})();
